import styled from '@emotion/styled';

export default styled.button<{ to?: string }>`
    display: inline-block;
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
    font-weight: 700;
`;
